import CabCancellationFeesForm from "@/components/CabCancellationFeesForm";
import CancellationFeesTable from "@/components/CancellationFeesTable";


export default function CabCancellationFeesPage(){
    return(
        <>
        <CabCancellationFeesForm/>
        <CancellationFeesTable/>
        </>
    )
}